import { PayloadAction } from '@reduxjs/toolkit';

import { IState } from '../types/state';
import { FavoriteFolderData } from 'dataSources/Typicode/favoriteCatalogs';

const action = (
  state: IState,
  payloadAction: PayloadAction<FavoriteFolderData>,
) => {
  const { folderId, stationCodes } = payloadAction.payload;

  state.catalogs.data = {
    ...state.catalogs.data,
    [folderId]: {
      ...state.catalogs.data[folderId],
      stationCodes,
    },
  };
};

export default action;
